/** Base z-index for the first open sheet (matches legacy `z-50`). */
export const BOTTOM_SHEET_BASE_Z = 50;
/** Each additional simultaneous sheet stacks +10 (z-60, z-70, …). */
export const BOTTOM_SHEET_LAYER_STEP = 10;

export function getSheetLayer(openIds: readonly string[], id: string): number {
  const index = openIds.indexOf(id);
  return index === -1 ? 0 : index + 1;
}

export function isTopSheet(openIds: readonly string[], id: string): boolean {
  return openIds.length > 0 && openIds[openIds.length - 1] === id;
}

export function sheetZIndex(layer: number): number {
  return layer === 0 ? BOTTOM_SHEET_BASE_Z : BOTTOM_SHEET_BASE_Z + (layer - 1) * BOTTOM_SHEET_LAYER_STEP;
}

export type BottomSheetStackStore = {
  subscribe: (listener: () => void) => () => void;
  getOpenIds: () => readonly string[];
  register: (id: string, open: boolean) => void;
};

export function createBottomSheetStackStore(): BottomSheetStackStore {
  let openIds: string[] = [];
  const listeners = new Set<() => void>();

  const notify = () => {
    for (const listener of listeners) listener();
  };

  return {
    subscribe(listener) {
      listeners.add(listener);
      return () => listeners.delete(listener);
    },
    getOpenIds() {
      return openIds;
    },
    register(id, open) {
      const has = openIds.includes(id);
      if (open && !has) {
        openIds = [...openIds, id];
        notify();
        return;
      }
      if (!open && has) {
        openIds = openIds.filter((entry) => entry !== id);
        notify();
      }
    },
  };
}
